import {
  createSerializationOptionsForEnumValue,
  serializationOptionsForStringArrayValue,
  serializationOptionsForStringValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';
import { stripPrefix } from 'utils/stringHelpers';
import { FILTER_PREFIXES, QUERY_PARAMS } from '../constants';
import { GoalStatus } from '../types';

const stripFiltersPrefixes =
  (setterFn: (value: string[]) => unknown, prefix: string) => (values: string[]) =>
    setterFn(values.map((value) => stripPrefix(prefix, value)));

export const useGoalsFilters = () => {
  const [searchQuery, setSearchQuery] = useSearchParamState({
    searchParamKey: QUERY_PARAMS.SEARCH,
    stateValueWhenSearchParamIsUnset: '',
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForStringValue,
  });

  const [creators, setCreators] = useSearchParamState({
    searchParamKey: QUERY_PARAMS.CREATORS,
    stateValueWhenSearchParamIsUnset: [],
    ...serializationOptionsForStringArrayValue,
  });
  const [modifiers, setModifiers] = useSearchParamState({
    searchParamKey: QUERY_PARAMS.MODIFIERS,
    stateValueWhenSearchParamIsUnset: [],
    ...serializationOptionsForStringArrayValue,
  });

  const [states, setStates] = useSearchParamState({
    searchParamKey: QUERY_PARAMS.STATES,
    stateValueWhenSearchParamIsUnset: [],
    ...serializationOptionsForStringArrayValue,
  });

  const [status, setStatus] = useSearchParamState<GoalStatus>({
    searchParamKey: QUERY_PARAMS.STATUS,
    stateValueWhenSearchParamIsUnset: GoalStatus.ALL,
    ...createSerializationOptionsForEnumValue<GoalStatus>({
      enumKeyValueMap: GoalStatus,
      stateValueWhenSearchParamIsInvalid: GoalStatus.ALL,
    }),
  });

  const clearFilters = () => {
    setCreators([]);
    setModifiers([]);
    setStates([]);
  };

  return {
    clearFilters,
    searchQuery,
    setSearchQuery,
    status,
    setStatus,
    states,
    setStates: stripFiltersPrefixes(setStates, FILTER_PREFIXES.STATE),
    creators,
    setCreators: stripFiltersPrefixes(setCreators, FILTER_PREFIXES.CREATOR),
    modifiers,
    setModifiers: stripFiltersPrefixes(setModifiers, FILTER_PREFIXES.MODIFIER),
  };
};
